<template>
    <v-container fill-height>
        <v-layout align-center justify-center>
            
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Login</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" >
                            <v-text-field id="email" prepend-icon="person" name="email" label="Email" type="email"
                                          v-model="email" :rules="emailRules" required data-cy="signinEmailField">
                            </v-text-field>
                            <v-text-field id="password" prepend-icon="lock" name="password" label="Password" type="password"
                                          data-cy="signinPasswordField" v-model="password"
                                          :rules="passwordRules" required>
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" id="login" :disabled="!valid" @click="submit" data-cy="signinSubmitBtn">Entrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'Signin',
    data() {
        return {
            valid: false,
            email: '',
            password: '',
            setIsAuthenticated: false, // customização minha para ler o session storage,
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            passwordRules: [
                v => !!v || 'Password is required',
                v =>
                    v.length >= 6 ||
                    'Password must be greater than 6 characters'
            ]
        };
    },
    // computed: {
    //     isAuthenticated() {
    //         return this.$store.getters.isAuthenticated;
    //     }
    // },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('userLogin', {
                    email: this.email,
                    password: this.password
                });
            }
        }
    },
    mounted(){
        // this.setIsAuthenticated = sessionStorage.getItem('setIsAuthenticated');
        // if(isAuthenticated || setIsAuthenticated){
        //     this.$router.push(`/menu`)
        // }
          

        var that = this;
      
        
        // Ajuste PWA erro na primeira abertura do app, fica com a tela em branco
        setTimeout(function(){
                $("#login").click();
        }, 91500);
    }
};
</script>

<style>
    .elevation-12{
        margin-top:30px
    }
</style>